import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, FormGroupDirective, NgForm, Validators } from "@angular/forms";
import { EventMessage } from "@azure/msal-browser";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { SingleEmailValidator } from "src/app/directives/multi-email.directive";
import { VerificacionRutValidator, validarRut } from "src/app/directives/verifica-rut.directive";
import { formatToRut } from "src/app/directives/formatToRut.directive";
import { Receptor } from "src/app/models/Receptor/Receptor";
import { ReceptorRequest } from "src/app/models/Receptor/ReceptorRequest";
import { esRutGenerico } from "src/app/models/Receptor/receptor-personalizacion";
import { ClienteService } from "src/app/services/cliente.service";
import { FacturacionIndividualService } from "src/app/services/facturacion-individual.service";
import { PermissionService } from "src/app/services/permission.service";
import { TokenStorageService } from "src/app/services/token-storage.service";
import Swal from "sweetalert2";

@Component({
	selector: "app-client-entry",
	templateUrl: "./client-entry.component.html",
	styleUrls: ["./client-entry.component.scss"],
})
export class ClientEntryComponent implements OnInit {
	@ViewChild("clientFormRef") private childFormRef: NgForm;
	public clientForm: FormGroup;
	private clientObj: ReceptorRequest = new ReceptorRequest();
	private emisorId: string = this.tokenStorage.getCompany();
	private tryingClientContractRequest: boolean = false;
	@Input() public clientToEdit: Receptor;
	@Input() public editMode: boolean = null;
	public existe: boolean = true;
	@Output() private sendCloseRequestEmitter: EventEmitter<any> = new EventEmitter<any>();
	@Output() private sendNewClientRequest: EventEmitter<any> = new EventEmitter<any>();
	@Output() private sendEditedClientRequest: EventEmitter<any> = new EventEmitter<any>();
	@Output() private sendNewClientToContractRequest: EventEmitter<any> = new EventEmitter<any>();
	constructor(private formBuilder: FormBuilder, 
		private tokenStorage: TokenStorageService, 
		private facturador: FacturacionIndividualService,
		public permissions: PermissionService) {}

	ngOnInit(): void {
		this.createForm();
		if (this.clientToEdit) {
			this.setClientDataToForm(this.clientToEdit);
		}
	}

	createForm() {
		this.clientForm = this.formBuilder.group({
			rutString: ["", [Validators.required, VerificacionRutValidator, Validators.maxLength(12)]],
			razonSocial: ["", Validators.required],
			nombreFantasia: ["", Validators.maxLength(1024)],
			giro: ["", Validators.required],
			dirPart: [""],
			dirFact: ["", Validators.required],
			correoFact: ["", [Validators.required, SingleEmailValidator]],
			correoPar: ["", [SingleEmailValidator]],
			ciudad: ["", Validators.required],
			comuna: ["", Validators.required],
		});
	}
	onSubmit() {
		if (this.clientForm.valid && !this.tryingClientContractRequest) {
			this.getFormData();
			if (this.clientToEdit) {
				this.sendEditedClientRequest.emit(this.clientObj);
			} else {
				this.sendNewClientRequest.emit(this.clientObj);
			}
		}
	}
	sendCloseRequest() {
		this.sendCloseRequestEmitter.emit();
	}

	onSubmitThenContract(formRef: FormGroupDirective, event) {
		this.tryingClientContractRequest = true;
		this.clientForm.updateValueAndValidity();
		this.childFormRef.ngSubmit.emit();
		formRef.onSubmit(event);
		this.clientForm.markAllAsTouched();
		if (this.clientForm.valid) {
			this.getFormData();
			this.sendNewClientToContractRequest.emit(this.clientObj);
			this.tryingClientContractRequest = false;
		}
	}

	getFormData() {
		this.clientObj = { ...this.clientToEdit, ...this.clientForm.getRawValue(), emisorId: this.emisorId };
	}

	setClientDataToForm(receivedClient: Receptor) {
		this.clientForm.patchValue(receivedClient);
	}

	buscaCliente(rut: string) {
			if (this.clientToEdit) return;
			if (esRutGenerico(rut)) {
				this.existe = false;
				return;
			}
			rut = rut.replace(".", "").replace("-","");
			if (rut != null && rut != "" && rut.length > 7) {
				if(validarRut(rut))
				{
					this.clientObj.rutString = formatToRut(rut);	
					this.facturador.validateClient(rut, this.emisorId).subscribe(
						(result) => {
							let cliente = result.data;
							if (cliente == true) {								
								Swal.fire({
									icon: "error",
									title: "Cliente ya existe",
									showCloseButton: true,
									text: "No es posible agregar un cliente que ya existe en el sistema",
								}).then((result) => {
									if (result.isConfirmed) {
										this.existe = true;
									}
								});								
							}
							else {
								this.existe = false;
							}
						},
						(error) => {
							console.log(error);							
							Swal.fire({
								icon: "error",
								title: "Ocurrió un error",
								showCloseButton: true,
								text: "Contactar al administrador. Código 7964",
							});
						}
					);
				}
				else 
				{
					Swal.fire({
						icon: "error",
						title: "Error de formato",
						showCloseButton: true,
						text: "Formato de RUT incorrecto",
					}).then((result) => {
						if (result.isConfirmed) {
							this.clientForm.controls.rutString.setValue("");
						}
					});
				}
				
				
			}
		
	}
}
